import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import { Row } from "./Row";
import { VideoCard } from "./VideoCard";

export const ContinueWatching = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!user) {
      setItems([]);
      return;
    }
    api.get("/watch/continue").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [user]);

  if (!items.length) return null;

  return (
    <Row
      testid="home-row-continue-watching"
      title={
        <span className="flex items-center gap-2.5">
          <History className="w-6 h-6 text-[#FF2A2A]" strokeWidth={2.5} />
          Continue Watching
        </span>
      }
    >
      {items.map((v) => (
        <div key={v.youtube_id} className="w-[220px] md:w-[300px] shrink-0">
          <VideoCard video={v} progress={v.progress} />
        </div>
      ))}
    </Row>
  );
};
